import { Component, Input, OnChanges } from '@angular/core';

const DEFAULT_WIDTH = "40px";

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss']
})
export class AvatarComponent implements OnChanges {
  @Input() src: string;
  @Input() size: string;
  @Input() alt: string;
  @Input() type: "square" | "circle" = "circle";

  width: string = DEFAULT_WIDTH;

  constructor() { }

  ngOnChanges(): void {
    if (!this.size) {
      this.width = DEFAULT_WIDTH;
    } else if (/^\d+$/.test(this.size)) {
      this.width = this.size + "px";
    } else {
      this.width = this.size;
    }
  }

}
